(() => {
  'use strict';
  const init = async (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const list = root.querySelector('[data-review-list]');
    const status = root.querySelector('[data-review-status]');
    const pagination = root.querySelector('[data-review-pagination]');
    const prev = root.querySelector('[data-review-prev]');
    const next = root.querySelector('[data-review-next]');
    const pageLabel = root.querySelector('[data-review-page]');
    const sort = root.querySelector('[data-review-sort]');
    const make = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const safeUrl = (value) => {
      try { const url = new URL(value); return url.protocol === 'https:' ? url.href : null; } catch (_) { return null; }
    };
    try {
      const response = await fetch(root.dataset.source);
      if (!response.ok) throw new Error('Reviews unavailable');
      const data = await response.json();
      const reviews = data.reviews;
      let filter = 'all';
      let page = 1;
      const perPage = 5;
      const dateFormat = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
      root.querySelector('[data-review-summary]').textContent = `${Number(data.average).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} / 5 — ${reviews.length} avis sur ce produit`;
      for (let rating = 1; rating <= 5; rating++) {
        const count = reviews.filter(r => Number(r.rating) === rating).length;
        root.querySelector(`[data-review-count="${rating}"]`).textContent = String(count);
        root.querySelector(`[data-review-bar="${rating}"]`).style.width = `${count / reviews.length * 100}%`;
      }
      const render = (moveFocus = false) => {
        const matching = reviews.filter(r => filter === 'all' || Number(r.rating) === Number(filter)).slice();
        matching.sort((a, b) => {
          const dateDiff = Date.parse(b.created_at) - Date.parse(a.created_at);
          if (sort.value === 'oldest') return -dateDiff || a.uuid.localeCompare(b.uuid);
          if (sort.value === 'highest') return b.rating - a.rating || dateDiff || a.uuid.localeCompare(b.uuid);
          if (sort.value === 'lowest') return a.rating - b.rating || dateDiff || a.uuid.localeCompare(b.uuid);
          return dateDiff || a.uuid.localeCompare(b.uuid);
        });
        const pages = Math.max(1, Math.ceil(matching.length / perPage));
        page = Math.min(page, pages);
        list.replaceChildren();
        matching.slice((page - 1) * perPage, page * perPage).forEach(r => {
          const article = make('article', 'kdn-reviews__card');
          article.dataset.sourceUuid = r.uuid;
          const header = make('div', 'kdn-reviews__card-header');
          const author = make('strong', 'kdn-reviews__author', r.reviewer_name);
          header.append(author);
          if (r.verified_buyer) header.append(make('span', 'kdn-reviews__verified', 'Achat vérifié'));
          const time = make('time', '', dateFormat.format(new Date(r.created_at)));
          time.dateTime = r.created_at;
          header.append(time);
          article.append(header);
          const location = [r.location, r.location_country].filter(Boolean).filter((x, i, a) => a.indexOf(x) === i).join(', ');
          if (location) article.append(make('p', 'kdn-reviews__location', location));
          const stars = make('p', 'kdn-reviews__stars', '★'.repeat(r.rating) + '☆'.repeat(5 - r.rating));
          stars.setAttribute('aria-label', `${r.rating} sur 5 étoiles`);
          article.append(stars);
          if (r.title) article.append(make('h3', '', r.title));
          article.append(make('p', 'kdn-reviews__body', r.body));
          if (r.pictures_urls && r.pictures_urls.length) {
            const photos = make('div', 'kdn-reviews__photos');
            r.pictures_urls.forEach((photo, index) => {
              const original = safeUrl(photo.original || photo.huge);
              if (!original) return;
              const link = make('a', '');
              link.href = original;
              link.target = '_blank';
              link.rel = 'noopener';
              link.setAttribute('aria-label', `Agrandir la photo ${index + 1} de l’avis de ${r.reviewer_name} (nouvel onglet)`);
              const image = make('img', '');
              image.src = safeUrl(photo.compact || photo.small) || original;
              image.alt = `Photo ${index + 1} jointe à l’avis de ${r.reviewer_name}`;
              image.width = 120;
              image.height = 120;
              image.loading = 'lazy';
              link.append(image);
              photos.append(link);
            });
            article.append(photos);
          }
          list.append(article);
        });
        status.textContent = matching.length ? `${matching.length} avis — affichage ${((page - 1) * perPage) + 1} à ${Math.min(page * perPage, matching.length)}` : 'Aucun avis avec cette note.';
        pagination.hidden = matching.length <= perPage;
        prev.disabled = page === 1;
        next.disabled = page >= pages;
        pageLabel.textContent = `Page ${page} sur ${pages}`;
        if (moveFocus) { status.tabIndex = -1; status.focus({ preventScroll: true }); }
      };
      root.querySelectorAll('[data-review-filter]').forEach(button => button.addEventListener('click', () => {
        filter = button.dataset.reviewFilter;
        page = 1;
        root.querySelectorAll('[data-review-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        render();
      }));
      sort.addEventListener('change', () => { page = 1; render(); });
      prev.addEventListener('click', () => { if (page > 1) { page--; render(true); } });
      next.addEventListener('click', () => { page++; render(true); });
      render();
    } catch (error) {
      status.textContent = 'Les avis ne sont pas disponibles pour le moment. Veuillez actualiser la page.';
      root.querySelectorAll('button, select').forEach(control => { control.disabled = true; });
    }
  };
  document.querySelectorAll('[data-kdn-reviews]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-kdn-reviews]').forEach(init));
})();
